import { put, takeEvery } from 'redux-saga/effects';

import { CustomerAction } from '../actions';
import { CustomerConstant } from '../constants';

export default function* () {
  yield takeEvery(CustomerConstant.GET_CUSTOMERS_SUCCESS, getCustomersSuccess);
}

function* getCustomersSuccess(action) {
  yield put(CustomerAction.setCustomers(action?.payload));
}
